import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logo-targus",
  "use": "icon-logo-targus-usage",
  "viewBox": "0 0 32 29",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 32 29\" id=\"icon-logo-targus\"><g><g><g></g><g><path d=\"M22,12.75L16,3L0,29L12,29L22,12.75Z\" fill-rule=\"evenodd\" fill=\"#2DCCA9\" fill-opacity=\"1\" /></g><g><path d=\"M20,29L32,29L23,14.375L17,24.125L20,29Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol